<template>
    <div class="svg-icon" v-if="icon" v-on="$listeners" v-bind="$attrs" v-html="icon"></div>
</template>

<script>
    import axios from 'axios';

    const iconCache = {};

    export default {
        name: "svgIcon",
        props: {
            iconURL: String,
        },
        asyncComputed: {
            icon() {
                if(!this.iconURL) return null;

                // This could potentially be loaded via dynamic imports which would do some cool caching and bundling same-tick
                // requests into one call to reduce overhead
                if(!iconCache[this.iconURL]) {
                    //TODO: Replace question mark with default svg icon
                    //Checking content-type header to more gracefully fail if the icon doesn't exist.
                    iconCache[this.iconURL] = axios.get(this.iconURL).then(res => (res.headers['content-type'] === "image/svg+xml") ? res.data : '?');
                }

                return iconCache[this.iconURL];
            },
        },
    }
</script>

<style lang="scss" scoped>

    .svg-icon svg{
        width: 30px;
        height: auto;
    }

</style>
